var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{fixed: _vm.fixed},style:([_vm.position, _vm.backgroundColor,_vm.zIndex]),attrs:{"id":"lm-component-loading"}},[_c('img',{attrs:{"src":require("@/assets/images/LmComponentLoading.svg"),"alt":"loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }